module.exports = __webpack_public_path__ + "img/zilan.3329165d.png";